import { z } from 'zod';
import { importRunSchema } from './salons.js';
/** Erkannte Formate von Altbestands-Dateien. */
export const legacyFormatSchema = z.enum(['flat', 'matrix', 'multisheet']);
/** Abfrageparameter des Altdaten-Imports. */
export const legacyImportQuerySchema = z.object({
    /** Vorschau (Standard) oder Echtlauf. */
    dryRun: z.enum(['true', 'false']).default('true'),
    /** Entscheidungsdatum für importierte Erfolge (Altdaten haben keins); ohne Angabe bleibt es leer. */
    decidedAt: z.iso.date().optional(),
});
/** Hinweis oder Fehler zu einer Zeile der Datei. */
export const legacyIssueSchema = z.object({
    level: z.enum(['error', 'warning']),
    /** Zeilennummer in der Datei (1-basiert) oder `null`. */
    line: z.number().int().nullable(),
    message: z.string(),
});
/** Zusammenfassung eines Altdaten-Imports (Vorschau oder Echtlauf). */
export const legacyImportSummarySchema = z.object({
    runId: z.number().int(),
    dryRun: z.boolean(),
    format: legacyFormatSchema,
    /** Anzahl gelesener Einträge (Bild × Wettbewerb). */
    records: z.number().int(),
    images: z.object({ created: z.number().int(), existing: z.number().int() }),
    competitions: z.object({
        created: z.number().int(),
        existing: z.number().int(),
        /** Davon mit dem Wettbewerbskatalog verknüpft. */
        linked: z.number().int(),
    }),
    submissions: z.object({
        created: z.number().int(),
        updated: z.number().int(),
        skipped: z.number().int(),
    }),
    issues: z.array(legacyIssueSchema),
});
/** Eigene Importläufe des Benutzers. */
export const legacyRunListSchema = z.object({ runs: z.array(importRunSchema) });
//# sourceMappingURL=legacy-import.js.map